/*
 * El rail: navy, 56px colapsado, 200px al pasar el cursor o con ⌘\.
 * Cinco destinos, como el prototipo del cliente. Un sexto candidato va dentro de
 * la cuenta o en la paleta, no aquí.
 */

import { NavLink, useLocation } from "react-router-dom";

import { sesion } from "../api/cliente";
import { nombreEquipo } from "../api/tipos";
import { Icono } from "../ui/primitivas";

export const DESTINOS = [
  { ruta: "/hoy", label: "Hoy", tecla: "H", icono: "M4 5h12M4 10h12M4 15h7" },
  { ruta: "/cuentas", label: "Cuentas", tecla: "C", icono: "M10 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM3.5 17.5c0-3.3 2.9-5.5 6.5-5.5s6.5 2.2 6.5 5.5" },
  { ruta: "/descubrimiento", label: "Descubrimiento", tecla: "D", icono: "M12.5 12.5L17 17M14 8.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z" },
  { ruta: "/proyectos", label: "Proyectos", tecla: "P", icono: "M5 2h7l3 3v13H5zM12 2v4h4" },
  { ruta: "/cxc", label: "CxC", tecla: "M", icono: "M10 2v16M13.5 6.5c0-1.4-1.6-2.5-3.5-2.5S6.5 5.1 6.5 6.5c0 3.5 7 1.5 7 5.5 0 1.4-1.6 2.5-3.5 2.5S6.5 13.4 6.5 12" },
];

export function Rail({ expandido, setExpandido, abrirPaleta, salir }: {
  expandido: boolean; setExpandido: (v: boolean) => void; abrirPaleta: () => void; salir: () => void;
}) {
  const { pathname } = useLocation();
  const w = expandido ? 200 : 56;
  const fade = { opacity: expandido ? 1 : 0, transition: "opacity 150ms" } as const;
  const activo = (ruta: string) => pathname === ruta || pathname.startsWith(ruta + "/") || (ruta === "/hoy" && pathname.startsWith("/verificacion"));
  return (
    <nav aria-label="Navegación principal" onMouseEnter={() => setExpandido(true)} onMouseLeave={() => setExpandido(false)}
      style={{ width: w, transition: "width 150ms cubic-bezier(.4,0,.2,1)", background: "var(--navy)", display: "flex", flexDirection: "column", flexShrink: 0, overflow: "hidden", zIndex: 20 }}>
      <div style={{ height: 56, display: "flex", alignItems: "center", paddingLeft: 16, position: "relative" }}>
        <img src="/assets/nexlum_icon.png" alt="" style={{ height: 22, width: "auto", position: "absolute", left: 17, opacity: expandido ? 0 : 1, transition: "opacity 150ms" }} />
        <img src="/assets/nexlum_wordmark_reversed.png" alt="Nexlum" style={{ height: 20, width: "auto", ...fade }} />
      </div>
      <div style={{ height: 1, background: "var(--navy-light)", margin: "0 12px 8px" }} />
      <button onClick={abrirPaleta} aria-label="Buscar (⌘K)"
        style={{ display: "flex", alignItems: "center", gap: 10, height: 36, margin: "2px 8px 10px", padding: "0 10px", borderRadius: "var(--r-control)", background: "var(--navy-light)", color: "#8FA3C0", whiteSpace: "nowrap", border: "1px solid #1B3A66" }}>
        <Icono d="M12 12l4 4M13 8a5 5 0 11-10 0 5 5 0 0110 0z" size={16} />
        <span style={{ flex: 1, textAlign: "left", fontSize: 12.5, ...fade }}>Buscar…</span>
        <span className="kbd" style={{ background: "transparent", borderColor: "#1B3A66", color: "#5A6E8C", ...fade }}>⌘K</span>
      </button>
      {DESTINOS.map((d) => {
        const on = activo(d.ruta);
        return (
          <NavLink key={d.ruta} to={d.ruta} aria-current={on ? "page" : undefined} className="rail-item"
            style={{ display: "flex", alignItems: "center", gap: 12, height: 40, margin: "2px 8px", padding: "0 11px", borderRadius: "var(--r-control)", color: on ? "#fff" : "#8FA3C0", background: on ? "var(--navy-light)" : "transparent", whiteSpace: "nowrap", borderLeft: on ? "2px solid var(--sky)" : "2px solid transparent", transition: "background 120ms", textDecoration: "none" }}>
            <Icono d={d.icono} />
            <span style={{ fontSize: 13, fontWeight: 500, ...fade }}>{d.label}</span>
          </NavLink>
        );
      })}
      <div style={{ flex: 1 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 12, height: 40, margin: "2px 8px", padding: "0 11px", color: "#8FA3C0", whiteSpace: "nowrap" }}>
        <span style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--sky)", color: "#fff", fontSize: 9.5, fontWeight: 600, display: "grid", placeItems: "center", flexShrink: 0 }}>{nombreEquipo(sesion.quien())[0]}</span>
        <span style={{ fontSize: 13, ...fade }}>{nombreEquipo(sesion.quien())}</span>
      </div>
      <button onClick={salir} aria-label="Cerrar sesión" title="Cerrar sesión" className="rail-item"
        style={{ display: "flex", alignItems: "center", gap: 12, height: 40, margin: "2px 8px", padding: "0 11px", borderRadius: "var(--r-control)", color: "#8FA3C0", whiteSpace: "nowrap", borderLeft: "2px solid transparent" }}>
        <Icono d="M8 3H4v14h4M13 6l4 4-4 4M17 10H8" />
        <span style={{ fontSize: 13, fontWeight: 500, ...fade }}>Cerrar sesión</span>
      </button>
      <div style={{ padding: "12px 0 14px 17px", color: "#5A6E8C", fontSize: 11, whiteSpace: "nowrap", ...fade }}>⌘\ colapsar · ? atajos</div>
    </nav>
  );
}
